import { Injectable } from '@angular/core';
import { ConfigurableBundleSlotType } from '@libs/shop/models';

@Injectable({ providedIn: 'root' })
export class ConfigurableBundleFormUiService {
  public getSlotLabelBySlotType(slotType: ConfigurableBundleSlotType): string {
    switch (slotType) {
      case 'free':
        return 'Gratisartikel';
      case 'choice': {
        return 'Paket-Artikel';
      }
      case 'mandatory':
        return 'Pflichtartikel';
    }
  }

  public getSlotDescriptionBySlotType(slotType: ConfigurableBundleSlotType): string {
    switch (slotType) {
      case 'free':
        return 'Gratis zu Ihrem Vorteil';
      case 'choice': {
        return 'Wählen Sie Ihre Paket-Artikel';
      }
      case 'mandatory':
        return 'Pflichtartikel';
    }
  }

  public findThresholdIndex(selectionAmount: number, thresholdSteps: number[]): number {
    if (thresholdSteps.length === 0) {
      return -1;
    }

    let index: number = -1;

    for (let i: number = 0; i < thresholdSteps.length; i++) {
      if (selectionAmount >= thresholdSteps[i]) {
        index = i;
      } else {
        break;
      }
    }

    return index;
  }
}
